import { BaseResponseSchema, createBaseResponseSchema } from '@server/schemas'
import { z } from 'zod'

export * from './payment.model'
export { default as PaymentModel } from './payment.model'
export * from './portone.model'

export type PaymentCouponSelectorStatus = 'EMPTY_COUPON' | 'NON_SELECT' | 'SELECTED_COUPON'
export type PaymentBottomSheetKey = 'REGISTER_COUPON' | 'SELECT_COUPON'

export const PAYMENT_BOTTOM_SHEET_KEYS = {
  REGISTER_COUPON: 'REGISTER_COUPON',
  SELECT_COUPON: 'SELECT_COUPON',
} satisfies Record<PaymentBottomSheetKey, PaymentBottomSheetKey>

export const checkPaymentStatusByPollingSchema = createBaseResponseSchema(
  z.object({
    status: z.enum(['pending', 'success', 'failed']),
  }),
)

export type CalculateDiscountedPriceResponse = BaseResponseSchema<number>

export type CheckPaymentStatusByPollingResponse = BaseResponseSchema<{
  status: 'pending' | 'success' | 'failed'
  extras: Nullable<{ classId?: string; isDuplicatePurchase?: boolean }>
}>

export type ValidatePaymentResponse = BaseResponseSchema<boolean>
